export default "assets/images/icons/instagram-8b74a23c.svg";